import { makeAutoObservable } from 'mobx'
import { type ISmartCallFlowIncomingCallStep } from 'entities/SmartCall/api/types'
import { FlowActionStore } from 'widgets/Flow'
import { type ISmartCallActionStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action'
import { type ISmartCallFlowActionType } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'

export class IncomingCallStore {
  static readonly type = 'incomingCall' satisfies ISmartCallFlowActionType
  static title = 'Incoming call'
  public readonly actionStore: ISmartCallActionStore

  constructor() {
    this.actionStore = new FlowActionStore({
      parentId: '',
      id: 'trigger',
      type: IncomingCallStore.type,
      name: IncomingCallStore.title,
      defaultWidth: 48,
      defaultHeight: 32,
    })
    makeAutoObservable(this)
  }

  get step(): ISmartCallFlowIncomingCallStep {
    return {
      id: 'trigger',
      type: 'trigger',
      next: this.actionStore.nextId || '',
    }
  }
}
